/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CustomQuestionnaireSummary } from './CustomQuestionnaireSummary';
import {
  CustomQuestionnaireSummaryFromJSON,
  CustomQuestionnaireSummaryFromJSONTyped,
  CustomQuestionnaireSummaryToJSON,
} from './CustomQuestionnaireSummary';

/**
 *
 * @export
 * @interface PaginatedCustomQuestionnaireSummaryList
 */
export interface PaginatedCustomQuestionnaireSummaryList {
  /**
   *
   * @type {number}
   * @memberof PaginatedCustomQuestionnaireSummaryList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedCustomQuestionnaireSummaryList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedCustomQuestionnaireSummaryList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<CustomQuestionnaireSummary>}
   * @memberof PaginatedCustomQuestionnaireSummaryList
   */
  results: Array<CustomQuestionnaireSummary>;
}

/**
 * Check if a given object implements the PaginatedCustomQuestionnaireSummaryList interface.
 */
export function instanceOfPaginatedCustomQuestionnaireSummaryList(
  value: object,
): value is PaginatedCustomQuestionnaireSummaryList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedCustomQuestionnaireSummaryListFromJSON(json: any): PaginatedCustomQuestionnaireSummaryList {
  return PaginatedCustomQuestionnaireSummaryListFromJSONTyped(json, false);
}

export function PaginatedCustomQuestionnaireSummaryListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedCustomQuestionnaireSummaryList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(CustomQuestionnaireSummaryFromJSON),
  };
}

export function PaginatedCustomQuestionnaireSummaryListToJSON(
  value?: PaginatedCustomQuestionnaireSummaryList | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(CustomQuestionnaireSummaryToJSON),
  };
}
